import React from 'react';
import {
  Card, CardBody, Col, ButtonToolbar,
} from 'reactstrap';
import MainIcon from 'mdi-react/CloudDownloadIcon';
import CheckboxMarkedCircleIcon from 'mdi-react/MagnifyIcon';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
  isTablet
} from "react-device-detect";

const EmailConfirmationCard = ( props ) => {

  return (
  <Col md={12}>
    <Card>
      <CardBody>
        <div className={`email-confirmation`}>
          <div className="email-confirmation__icon">
            <MainIcon className="email-confirmation__mail" />
          </div>
          <h3 className="email-confirmation__title">{`You Haven't Exported Any Data Yet`}</h3>
          <p style={{fontSize:16}}>You can export building and unit data wherever you see the above download icon.</p>
          <ButtonToolbar className="email-confirmation__buttons">
            
		     <a href="https://help.marketproof.com/en/articles/4857038-guide-to-exporting-data-on-marketproof-new-development" target="_blank">
            <Button
		         variant="contained"
		         color="primary"
		         className="buyersList__primary-button"		         
		         startIcon={null}
		     >	Learn More About Data Exports
		     </Button>	
		     </a>
		     
          </ButtonToolbar>
        </div>
      </CardBody>
    </Card>
  </Col>
  )
};


export default EmailConfirmationCard;
